import _extends from '@babel/runtime/helpers/esm/extends';
import * as React from 'react';

var CheckCircleFill = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 2a10 10 0 1010 10A10.02 10.02 0 0014 2zm4.76 8.25l-5.635 5.385a.78.78 0 01-.539.211.74.74 0 01-.528-.211L9.24 12.942a.77.77 0 111.058-1.115l2.288 2.183 5.116-4.875a.77.77 0 011.058 1.115z",
    fill: "#888"
  }));
});
CheckCircleFill.displayName = 'CheckCircleFill';

export { CheckCircleFill, CheckCircleFill as default };
